// extracted by mini-css-extract-plugin
export default {"container":"SignUpPage_container__qdBxK","stageDotsFrame":"SignUpPage_stageDotsFrame__ylOcd","signupFrame":"SignUpPage_signupFrame__1xdaJ"};